import { generatePath } from 'react-router-dom';
import { jobIcon, personIcon } from '@/assets/images';
import ConstituentType from '@/constants/ConstituentType';
import translate from '@/lib/intl/translate';
import AuthRoutes from '../routing/AuthRoutes';

const AddNewConstituentConfig = [
  {
    iconSrc: personIcon,
    path: generatePath(AuthRoutes.CONSTITUENT_NEW, {
      constituentType: ConstituentType.PERSON,
    }),
    label: translate('CONSTITUENTS_NEW_CONSTITUENT_INDIVIDUAL_LABEL'),
  },
  {
    iconSrc: jobIcon,
    path: generatePath(AuthRoutes.CONSTITUENT_NEW, {
      constituentType: ConstituentType.ORG,
    }),
    label: translate('CONSTITUENTS_NEW_CONSTITUENT_ORG_LABEL'),
  },
];

export default AddNewConstituentConfig;
